<template>
  <div
    class="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-200"
  >
    <div class="max-w-7xl mx-auto pt-10 px-4">
      <ApiKeyManager />
      <ApiKeyDocs />
    </div>
  </div>
</template>

<script>
import ApiKeyManager from "@/components/ApiKeyManager.vue";
import ApiKeyDocs from "@/components/ApiKeyDocs.vue";

export default {
  name: "ApiKeys",
  components: {
    ApiKeyManager,
    ApiKeyDocs,
  },
};
</script>
